import type { Locale } from '../i18n/language';

interface GetLocaleLinkProps {
  page?: string;
  locale: Locale;
}

export default function getLocaleLink({ page, locale }: GetLocaleLinkProps): string {
  return `https://stefan-studios.nl${
    locale === 'nl' ? '' : (`/${locale}`)
  }${
    page !== undefined ? (`/${page}`) : ''
  }`;
}
